import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  popoverSurface: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    maxWidth: "280px",
    padding: designTokens.spacing[4],
  },
  popoverCloseButton: {
    position: "absolute",
    top: designTokens.spacing[2],
    right: designTokens.spacing[2],
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "24px",
    minHeight: "24px",
    padding: designTokens.spacing[1],
    background: "none",
    border: "none",
    cursor: "pointer",
    color: designTokens.neutral[500],
    borderRadius: designTokens.borderRadius.sm,
    ":hover": {
      color: designTokens.neutral[700],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
});
